import type { ComparisonTier } from './plan-comparison-v4';

/**
 * What the plan cards on /upgrade and the comparison table under them share.
 * The cards show the catalog's own words for each plan (`description` and
 * `features`), as the product describes itself; cleanlist.ai/pricing words
 * its cards for the site. A card's price and credits come from the catalog
 * too.
 */

/** The plans with a card. Enterprise has a band of its own. */
export type PlanCardTier = Exclude<ComparisonTier, 'enterprise'>;

/** The line over each paid card's list: what the plan adds to. Free's band
 *  lists its features under its own "What's in Free" disclosure instead. */
export const PLAN_CARD_INHERITS: Record<
  Exclude<PlanCardTier, 'free'>,
  string
> = {
  starter: 'Everything in Free, plus:',
  pro: 'Everything in Starter, plus:',
};

/** The size of the people index that search runs on. */
export const PROFILE_COUNT = '1B+';

/** The providers the enrichment waterfall runs through. */
export const PROVIDER_COUNT = '25+';

/** Free's searches: a count that never resets. A search is one page of 25
 *  results; Free stays at 5 (Lev, 2026-10-30). */
export const FREE_SEARCHES = 5;

/** Starter's searches a month, billing's STARTER_SEARCH_GRANT. */
export const STARTER_MONTHLY_SEARCHES = 1000;
